import(/* webpackMode: "eager" */ "/app/packages/apps/maui/app/(public)/shop/error.tsx");
